export function countryCodeToFlag(code: string): string {
  return String.fromCodePoint(
    ...[...code.toUpperCase()].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65),
  );
}

const displayNames = new Intl.DisplayNames(['en'], { type: 'region' });

export function countryCodeToName(code: string): string {
  return displayNames.of(code.toUpperCase()) ?? code;
}
